import React, { Component } from 'react';
import { connect } from 'react-redux';

class CustomLoadingOverlay extends Component {
  render() {
    const { language, loadingMessage } = this.props;
    return (
      <div
        className="ag-overlay-loading-center"
        style={{ height: '9%' }}
      >
        <span className="fas fa-hourglass-half"> {language[loadingMessage]} </span>
      </div>
    );
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(CustomLoadingOverlay)